import { type ThemeOptionVariant, useTheme } from '@dhl-ui/theme'

/**
 * Is it compliant for your variant. Please note that we have `RenderOn` in case you
 * want to paint something for a specific variant only inside a specific view.
 */
export const useIsVariant = (arg: ThemeOptionVariant[]) => {
  const { variant } = useTheme()

  return arg.includes(variant)
}
